import useLoanStatus from "../../hooks/auth/useLoanStatus";
import { EligibilityStatus } from "../../services/authService/AuthService.type";
import { routes, EligibilityRoutes } from "../../Routes";
import { useMemo } from "react";

const useEligibilityRouting = () => {
  const { status } = useLoanStatus();

  return useMemo(() => {
    const [eligibilityRouteByStatus, completedTillIndex] = getEligibilityRoute(
      status
    );
    return { eligibilityRouteByStatus, completedTillIndex };
  }, [status]);
};

export const getEligibilityRoute = (
  eligibilityStatus: EligibilityStatus | null
): [
  string, //route
  number //number which indicates the form count(CompanyFold: 1 .....)
] => {
  //returning [string, number] to avoid writing exactly same switch case twice
  switch (eligibilityStatus) {
    case null:
      return [routes.home.initializeEligibility, -1];
    case EligibilityStatus.CompanyDetailsFold:
      return [routes.eligibility.view(EligibilityRoutes.CompanyFold), 1];
    case EligibilityStatus.ApplicantDetailsFold:
      return [routes.eligibility.view(EligibilityRoutes.ApplicantFold), 2];
    case EligibilityStatus.ReceivablesFold:
      return [routes.eligibility.view(EligibilityRoutes.ReceivablesFold), 3];
    case EligibilityStatus.InsufficientGSTRData:
    case EligibilityStatus.AwaitingPrincipleAmount:
    case EligibilityStatus.EligibilityAmountFold:
    case EligibilityStatus.PrincipleAmountShared:
    case EligibilityStatus.PrincipleAmountRejected:
      return [
        routes.eligibility.view(EligibilityRoutes.EligibilityAmountFold),
        4
      ];

    case EligibilityStatus.PrincipleAmountAccepted:
      return [routes.eligibility.bankAccountDetails, 6];

    default:
      return [routes.eligibility.kyc, 7];
  }
};

export default useEligibilityRouting;
